<template>
  <div>
    <div v-if="isEnabled == 0" class="enableCard">
      <div class="d-flex flex-column enableCardInner">
        <div class="title">{{ $t('gateways.proxyRecordPassive') }}</div>
        <div class="detail">{{ $t('gateways.enableProxyInfo') }}</div>
        <div class="mx-auto">
          <button
            class="btn btn-primary d-block px-12 py-3 rounded"
            ref="enable_button"
            @click="enableService"
          >
            {{ $t('gateways.activate') }}
          </button>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- List Table -->
      <List
        :header="header"
        :data="data"
        :pagination="pagination"
        :loading="loading"
        @updatePage="updatePage"
      >
        <!-- <template v-slot:item.action="{ item }">
          <b-dropdown class="actions-button nomaxh"
                      variant="dark"
                      :text="$t('global.actions')">
            <b-dropdown-item class="dropdownAlertLabel"
                             @click.native="terminateOperation(item)">{{$t('servers.terminate')}}</b-dropdown-item>
          </b-dropdown>
        </template> -->
      </List>
      <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />

      <b-button
        type="button"
        variant="primary"
        @click="openDetail"
        class="px-10 mt-5"
        >{{ $t('gateways.createProxyHostRecord') }}</b-button
      >
    </div>

    <!-- Create Popup -->
    <DetailModal
      :title="$t('gateways.createProxyHostRecord')"
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
    >
      <ProxyCreate
        :confirmModal="confirmCreate"
        :gatewayId="gatewayId"
        @resetDetailForm="resetDetailForm"
      />
    </DetailModal>
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'
import EventBus from '@/event-bus'

export default {
  name: 'GatewayProxyRecords',
  data() {
    return {
      loading: false,
      showDetail: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        { text: 'global.domain', value: 'domain_name' },
        { text: 'global.ipAddress', value: 'ip_address' },
        { text: 'global.port', value: 'port' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
    }
  },
  props: {
    vmId: {
      type: String,
      default: '',
    },
    gatewayId: {
      type: String,
      default: '',
    },
    isEnabled: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      if (this.isEnabled == 1) {
        this.loading = true

        const { current_page } = this.meta
        let $query = `packetbender/netgateways/${this.gatewayId}/proxy?position=id|desc`

        ApiService.get($query)
          .then(({ data }) => {
            this.data = data
            // this.pagination = data.meta ? data.meta.pagination : {}

            this.loading = false
          })
          .catch((err) => {
            console.log(err)
            this.data = []
            this.loading = false
          })
      }
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    terminateOperation(item) {
      this.deleteOperationUrl = `packetbender/proxy/records/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    enableService() {
      this.enableButton = this.$refs['enable_button']
      this.$spinnerLoader.addSpinnerLoader(this.enableButton)

      ApiService.post(`packetbender/netgateways/${this.gatewayId}/proxy`)
        .then(({ data }) => {
          EventBus.$emit('reloadGatewayDetail')
        })
        .catch((err) => {
          this.$spinnerLoader.removeSpinnerLoader(this.enableButton)
        })
    },
    openDetail() {
      this.showDetail = true
    },
    closeDetail() {
      this.showDetail = false
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    ProxyCreate: () => import('@/components/forms/GatewayProxyCreate'),
  },
}
</script>
